// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"7ebaa317","220":"0a1cadfb","366":"5ff42e1b","367":"87181f8d","784":"38e3c145","867":"be562d9b","916":"91ff0cc1"}[chunkId] + ".css";
};